import { initErrorReporting } from "../error_reporting";
import "../cable";
import "../streamcommand";
import "../emotes";
import "../stimulus_app";

// Installs the global error handlers (StreamCommand-i3cp). No-ops without a
// DSN. ES module imports are hoisted, so a top-level throw inside one of the
// modules above still escapes this — everything after does not.
initErrorReporting("dashboard");
